<template lang="html">
    <Popup class="selectGoods" position="bottom" v-model="isShow">
        <div class="btn">
            <a href="javascript:void(0)" @click="onClearAllSelect">清空</a>
        </div>
        <ul class="list">
            <li class="li" v-for="item in selectList" :key="item.id">
                <p class="name">{{ item.name }}</p>
                <span class="price">￥{{ item.price }}</span>
                <span class="number">{{ item.number }}</span>
            </li>
        </ul>
    </Popup>
</template>
<script>
import {
    Popup
} from 'vant'
import eventBus, { ADVICE_SHOW_POP } from 'utils/eventBus.js'

export default {
    name: 'selectGoods',
    props: {
        selectList : {
            type: Array,
            default () {
                return []
            }
        }
    },
    components: {
        Popup
    },
    data () {
        return {
            isShow: false
        }
    },
    watch:{
    },
    created () {
    },
    methods:{
        show () {
            this.isShow = !this.isShow
            eventBus.$emit(ADVICE_SHOW_POP, this.isShow)
        },
        /**
         * 清除内容
         */
        onClearAllSelect () {
            this.isShow = false
            this.$emit('onClearAllSelect')
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/stylus/variables.styl'
@import '~@/assets/stylus/mixin.styl'
.selectGoods
    width 100%
    font-size 0
    margin-bottom 100px
    .btn
        height 80px
        line-height 80px
        text-align right
        padding 0 30px
        background  #f0f0f0
        a
            font-size 28px
            color #fc2d2d
    .list
        height 600px
        overflow-y scroll
        .li
            padding 32px
            min-height 128px
            box-sizing border-box
            border-bottom 1px solid #efefef
            display flex
            vertical-align top
            .name
                flex 1
                font-size 28px
                color #666666
                line-height 36px
                mutiLineTextOverFlow(2)
            .price
                color #333333
                font-size 28px
                line-height 36px
                margin 0 80px 0 55px
            .number
                display inline-block
                width 36px
                text-align right
                font-size 28px
                line-height 36px
                color #666666
</style>
